import Tabs from 'components/Tabs/Tabs';

import { useLocation, matchPath, Link } from 'react-router-dom';

export default ({ tabs }) => {
  const location = useLocation();

  const activeIndex = tabs.findIndex(tab =>
    matchPath({ path: tab.to, end: !!tab.exact }, location.pathname)
  );

  return (
    <Tabs
      tabs={tabs.map((tab, i) => ({
        ...tab,
        active: i === activeIndex,
        component: Link,
        props: { to: tab.to },
      }))}
    />
  );
};
